// @flow
import React from 'react';
import styled from 'styled-components';

import { Card, ComboBoxInput, Button } from 'primitive-components';
import type { SegmentCategory, GlobalSegmentCategory } from './types';
import SegmentListFormContainer from './SegmentListFormContainer';

const SegmentEditorWrapper = styled.div`
  display: flex;
`;

const ComboBoxInputWrapper = styled.div`
  padding-right: 8px;
  width: 300px;
`;

const StyledCard = styled(Card)`
  background: ${props => props.backgroundColour};
  padding: 16px ${props => props.padding || '24px'};
`;

type SegmentCategoryOption = {
  label: string,
  value: GlobalSegmentCategory,
};

type SegmentEditorProps = {
  clientId: string,
  availableCategories: Array<GlobalSegmentCategory>,
  segmentCategory: ?SegmentCategory,
  onCategoryAssigned: GlobalSegmentCategory => Promise<any>,
  isInitialEditor: boolean,
};

type SegmentEditorState = {
  selectedCategory: ?SegmentCategoryOption,
};

/**
 * Provides the UI for editing a single segment category and its segment
 * values.
 */
export default class SegmentEditor extends React.Component<SegmentEditorProps, SegmentEditorState> {
  constructor(props: SegmentEditorProps, context: any) {
    super(props, context);
    this.state = {
      selectedCategory: undefined,
    };
    this.segmentCategoryOptions = this.props.availableCategories.map(value => ({
      value,
      label: value.name,
    }));
  }

  segmentCategoryOptions: Array<SegmentCategoryOption>;

  selectSegmentCategory = (selectedCategory: SegmentCategoryOption) => {
    this.setState({ selectedCategory });
  };

  assignSegmentCategory = () => {
    if (!this.state.selectedCategory) {
      throw new Error('Missing selected category in SegmentEditor');
    }
    this.props.onCategoryAssigned(this.state.selectedCategory.value);
  };

  render() {
    const { clientId, segmentCategory, isInitialEditor } = this.props;

    return (
      <StyledCard
        elevation={!segmentCategory ? 0 : 1}
        backgroundColour={!segmentCategory ? 'transparent' : 'white'}
        padding={!segmentCategory ? '0' : ''}
      >
        {(() => {
          if (segmentCategory) {
            return (
              <SegmentListFormContainer clientId={clientId} segmentCategory={segmentCategory} />
            );
          }
          return (
            <SegmentEditorWrapper>
              <ComboBoxInputWrapper>
                <ComboBoxInput
                  clearable={false}
                  openOnFocus
                  placeholder={<span>Select Business Area to Track</span>}
                  value={this.state.selectedCategory}
                  options={this.segmentCategoryOptions}
                  onChange={this.selectSegmentCategory}
                />
              </ComboBoxInputWrapper>
              <Button
                disabled={!this.state.selectedCategory}
                styleType={!this.state.selectedCategory ? '' : 'primary'}
                onClick={this.assignSegmentCategory}
              >
                {isInitialEditor ? 'Get Started' : 'Add'}
              </Button>
            </SegmentEditorWrapper>
          );
        })()}
      </StyledCard>
    );
  }
}
